import * as React from "react";
import {
  BODetailTopBar,
  BODetailTopBarItem
} from "app/components/BOComponents/BODetailTopBar/BODetailTopBar";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

type Props = {
  billersCreateUrlQuery: any;
  categoriesCreateUrlQuery: any;
};

const GeneralTopBar = (props: Props) => {
  return (
    <BODetailTopBar>
      <BODetailTopBarItem
        text="By Category"
        link={`/snapscan/ops/biller_categories/summary`}
      />
      <BODetailTopBarItem
        text="All Billers"
        link={`/snapscan/ops/biller_categories/billers`}
      />
      {!!props.billersCreateUrlQuery.snapmin_create_url ? (
        <a
          className="BODetailTopBarItem"
          target="_blank"
          rel="noopener noreferrer"
          href={props.billersCreateUrlQuery.snapmin_create_url}
        >
          Add New Biller
        </a>
      ) : null}
      {!!props.categoriesCreateUrlQuery.snapmin_create_url ? (
        <a
          className="BODetailTopBarItem"
          target="_blank"
          rel="noopener noreferrer"
          href={props.categoriesCreateUrlQuery.snapmin_create_url}
        >
          Add New Category
        </a>
      ) : null}
    </BODetailTopBar>
  );
};

const billersCreateUrlQuery = graphql<any, any>(
  gql`
    query billersCreateUrlQuery {
      snapmin_create_url(class_name: "biller")
    }
  `,
  { name: "billersCreateUrlQuery" }
);

const categoriesCreateUrlQuery = graphql<any, any>(
  gql`
    query categoriesCreateUrlQuery {
      snapmin_create_url(class_name: "category")
    }
  `,
  { name: "categoriesCreateUrlQuery" }
);

export default compose(
  billersCreateUrlQuery,
  categoriesCreateUrlQuery
)(GeneralTopBar);
